export const getSelectOptionsFromEnum = <T extends object>(
    arg: T
): { value: string; label: string }[] =>
    Object.entries(arg).map(([key, value]) => ({
        value: value,
        label: key,
    }));
